import axios from '@/axios.js'
let entityURL = 'dealers'; // variant depending on entity URLs
let token = localStorage.getItem('accessToken');
let apiEndpoint = localStorage.getItem('apiEndpoint');
axios.defaults.baseURL = apiEndpoint;
axios.defaults.headers.common = { 'Authorization': `bearer ${token}` }

const state = {
    dealers: [],
    dealer: {},
    dealerGroups: [],
}

const getters = {
    getDealers: (state) => (state.dealers),
    getDealer: (state) => (state.dealer),
}

const actions = {
    // Add dealer
    async addDealer({ commit }, payload) {
        const response = await axios.post(`${entityURL}/add`, payload)
        commit('ADD_DEALER', response.data.object)
    },

    // Fetch dealers
    async fetchDealers({ commit }) {
        const response = await axios(`${entityURL}/list`)
        commit('SET_DEALERS', response.data)
    },

    // Fetch dealer
    async fetchDealer({ commit }, payloadId) {
        // SOS:: Αυτό το end point δεν υπάρχει στο api
        const response = await axios(`${entityURL}/get/${payloadId}`)
        commit('SET_DEALER', response.data)
    },

    // Set dealer
    setDealer({ commit }, payload) {
        commit('SET_DEALER', payload)
    },

    // Set dealer name
    setDealerName({ commit }, value) {
        commit('SET_DEALER_NAME', value)
    },

    // Set dealer status
    setDealerStatus({ commit }, value) {
        commit('SET_DEALER_STATUS', value)
    },

    // Set dealer phone
    setDealerPhone({ commit }, value) {
        commit('SET_DEALER_PHONE', value)
    },

    // Set dealer mobile
    setDealerMobile({ commit }, value) {
        commit('SET_DEALER_MOBILE', value)
    },

    // Set dealer address
    setDealerAddress({ commit }, value) {
        commit('SET_DEALER_ADDRESS', value)
    },

    // Set dealer city
    setDealerCity({ commit }, value) {
        commit('SET_DEALER_CITY', value)
    },

    // Set dealer postcode
    setDealerPostcode({ commit }, value) {
        commit('SET_DEALER_POSTCODE', value)
    },

    // Set dealer region
    setDealerRegion({ commit }, value) {
        commit('SET_DEALER_REGION', value)
    },

    // Set dealer email
    setDealerEmail({ commit }, value) {
        commit('SET_DEALER_EMAIL', value)
    },

    // Update dealer
    async updateDealer({ commit }, payload) {
        const response = await axios.put(`${entityURL}/update/${payload.dealerId}`, payload)
        commit('UPDATE_DEALER', response.data.object)
    },

    // Delete dealer
    async deleteDealer({ commit }, payloadId) {
        // SOS:: Αυτό το end point δεν υπάρχει στο api
        const response = await axios.delete(`${entityURL}/delete/${payloadId}`)
        if (response.data.message === 'Successfully Deleted') {
            commit('DELETE_DEALER', payloadId)
        }
    },

    // Fetch dealer groups
    async fetchDealerGroups({ commit }) {
        const response = await axios(`dealersGroups/list`)
        commit('SET_DEALER_GROUPS', response.data)
    },
}

const mutations = {
    ADD_DEALER: (state, data) => (state.dealers.push(data)),
    SET_DEALERS: (state, data) => (state.dealers = data),
    SET_DEALER: (state, data) => (state.dealer = data),
    UPDATE_DEALER: (state, data) => {
        const dealerIndex = state.dealers.findIndex(x => x.id === data.id)
        if (dealerIndex !== -1) {
            state.dealers.splice(dealerIndex, 1, data)
        }
    },
    DELETE_DEALER: (state, data) => {
        const dealerIndex = state.dealers.findIndex(x => x.id === data)
        if (dealerIndex !== -1) {
            state.dealers.splice(dealerIndex, 1)
        }
    },
    SET_DEALER_GROUPS: (state, data) => (state.dealerGroups = data),
    SET_DEALER_NAME: (state, data) => (state.dealer.name = data),
    SET_DEALER_STATUS: (state, data) => (state.dealer.dealer_status = data),
    SET_DEALER_PHONE: (state, data) => (state.dealer.phone = data),
    SET_DEALER_MOBILE: (state, data) => (state.dealer.mobile = data),
    SET_DEALER_ADDRESS: (state, data) => (state.dealer.address = data),
    SET_DEALER_CITY: (state, data) => (state.dealer.city = data),
    SET_DEALER_POSTCODE: (state, data) => (state.dealer.postcode = data),
    SET_DEALER_REGION: (state, data) => (state.dealer.region = data),
    SET_DEALER_EMAIL: (state, data) => (state.dealer.email = data),
}


export default { state, getters, actions, mutations }
